/* tslint:disable */
/* eslint-disable */
/**
 * AusgabeAutomatConnector
 * Connector für Ausgabeautomat zu ORSY Gateway und BDS Gateway.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockMovement
 */
export interface StockMovement {
    /**
     * 
     * @type {string}
     * @memberof StockMovement
     */
    movementId: string;
    /**
     * 
     * @type {string}
     * @memberof StockMovement
     */
    idProduct: string;
    /**
     * 
     * @type {string}
     * @memberof StockMovement
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof StockMovement
     */
    eventTime: string;
    /**
     * 2 - Takeout/Entnahme
     * 10 - Return/Rückgabe
     * 11 - Inventory/Inventur
     * 12 - Set to empty/Leer setzen
     * 13 - Incoming goods/Wareneingang
     * 14 - Open/Öffnen
     * 20 - Takeout from rental box/Entnahme Verleihbox
     * 21 - Return to rental box/Rückgabe Verleihbox
     * 22 - Storno Buchung
     * 30 - Incoming goods to packstation/Wareneingang Packstation
     * 31 - Takeout from packstation/Entnahme Packstation
     * 40 - Product check/Produktprüfung
     * 41 - Return (check)/Rückgabe (Prüfung)
     * 50 - Order group check
     * 999 - Defekter Artikel (Prüfung durch Magazin) - Interner Sonderstatus, nicht in Boostrack-API enthalten
     * 
     * @type {number}
     * @memberof StockMovement
     */
    reason: number;
    /**
     * 
     * @type {string}
     * @memberof StockMovement
     */
    idEmployee: string;
    /**
     * 
     * @type {string}
     * @memberof StockMovement
     */
    employeeName: string;
    /**
     * 
     * @type {string}
     * @memberof StockMovement
     */
    idCostCenter: string;
    /**
     * 
     * @type {number}
     * @memberof StockMovement
     */
    quantity: number;
}

/**
 * Check if a given object implements the StockMovement interface.
 */
export function instanceOfStockMovement(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "movementId" in value;
    isInstance = isInstance && "idProduct" in value;
    isInstance = isInstance && "productName" in value;
    isInstance = isInstance && "eventTime" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "idEmployee" in value;
    isInstance = isInstance && "employeeName" in value;
    isInstance = isInstance && "idCostCenter" in value;
    isInstance = isInstance && "quantity" in value;

    return isInstance;
}

export function StockMovementFromJSON(json: any): StockMovement {
    return StockMovementFromJSONTyped(json, false);
}

export function StockMovementFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockMovement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'movementId': json['movementId'],
        'idProduct': json['idProduct'],
        'productName': json['productName'],
        'eventTime': json['eventTime'],
        'reason': json['reason'],
        'idEmployee': json['idEmployee'],
        'employeeName': json['employeeName'],
        'idCostCenter': json['idCostCenter'],
        'quantity': json['quantity'],
    };
}

export function StockMovementToJSON(value?: StockMovement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'movementId': value.movementId,
        'idProduct': value.idProduct,
        'productName': value.productName,
        'eventTime': value.eventTime,
        'reason': value.reason,
        'idEmployee': value.idEmployee,
        'employeeName': value.employeeName,
        'idCostCenter': value.idCostCenter,
        'quantity': value.quantity,
    };
}

